import * as fs from 'node:fs';
import { isBridgeRootCheckoutPath } from '../../worktrees/is-removable-session-worktree-checkout-path.js';
import { cliSimpleGit } from '../cli-simple-git.js';
import { resolveMainRepoFromWorktreeGitFile } from './resolve-main-repo-from-git-file.js';

/** `false` when skipped (bridge root) — does not throw for that case. */
export async function gitWorktreeRemoveForce(worktreePath: string): Promise<boolean> {
  const mainRepo = resolveMainRepoFromWorktreeGitFile(worktreePath);
  if (mainRepo) {
    await cliSimpleGit(mainRepo).raw(['worktree', 'remove', '--force', worktreePath]);
    return true;
  }
  if (isBridgeRootCheckoutPath(worktreePath)) return false;
  fs.rmSync(worktreePath, { recursive: true, force: true });
  return true;
}
